import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PreloaderComponent } from './preloader/preloader.component';
import { TravelerComponent } from './traveler/traveler.component';

const routes: Routes = [
  { path: '', component: PreloaderComponent },
  { path: 'traveler',  component: TravelerComponent },
  { path: 'traveler/:type',  component: TravelerComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule {

  
}
